module.exports = __webpack_public_path__ + "static/media/my_parties.b11dad4d.svg";